<div class="mt-table-wrapper">
  @if (headers && headers.length > 0 && notFoundMsg === null) {
    <div class="mt-table-body">
      <mat-table
        #table
        [dataSource]="rowsData"
        matSort
        (matSortChange)="onSort($event)"
        >
        <!-- Checkbox Column -->
        <ng-container matColumnDef="select" sticky>
          <mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              color="primary"
              [disabled]="headerDisabled"
              (change)="$event ? masterToggle() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()"
              [aria-label]="checkboxLabel()"
              >
            </mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <mat-checkbox
              color="primary"
              (click)="$event.stopPropagation()"
              [disabled]="disabledCheckbox(row)"
              (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row)"
              [aria-label]="checkboxLabel(row)"
              >
            </mat-checkbox>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="button" sticky>
          <mat-header-cell *matHeaderCellDef> &nbsp; </mat-header-cell>
          <mat-cell *matCellDef="let row">
            @if (row.isVerified === 0) {
              <mt-btn class="link" (onAction)="onBtnAction(row)">
                <mat-icon>security</mat-icon>
                Verify
              </mt-btn>
            }
            @if (row.isVerified === 1) {
              <mt-btn class="link success">
                <mat-icon>check</mat-icon>
                Verified
              </mt-btn>
            }
            @if (row.isVerified === 2) {
              <mt-btn class="link error" (onAction)="onBtnAction(row)">
                <mat-icon>error_outline</mat-icon>
                Rejected
              </mt-btn>
            }
          </mat-cell>
        </ng-container>
        @for (header of headers; track header) {
          <ng-container
            [cdkColumnDef]="header.name"
            >
            <mat-header-cell *cdkHeaderCellDef mat-sort-header>
              {{ header.name | translate }}
            </mat-header-cell>
            <mat-cell
              *cdkCellDef="let row"
              [cdkCopyToClipboard]="row | dataFormatter : row : header.prop"
              (cdkCopyToClipboardCopied)="onCopy(header.name, $event)"
              >
              <span class="cell-data-width" [ngClass]="header.cellClass">{{
                row | dataFormatter : row : header.prop | formatter : header.pipe
              }}</span>
            </mat-cell>
          </ng-container>
        }
        <mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumns; let rowIndex = index"
          (dblclick)="gotToTimeline(row)"
          (click)="onRowClickAction(row)"
          [ngClass]="getRowClass(row)"
          >
        </mat-row>
      </mat-table>
    </div>
  }
  @if (notFoundMsg) {
    <mt-text-medium class="ta-c">
      {{ notFoundMsg }}
    </mt-text-medium>
  }
</div>
